import { render, staticRenderFns } from "./StudyResultListTable.vue?vue&type=template&id=53fa3c38&scoped=true&lang=pug"
import script from "./StudyResultListTable.vue?vue&type=script&lang=ts"
export * from "./StudyResultListTable.vue?vue&type=script&lang=ts"
import style0 from "./StudyResultListTable.vue?vue&type=style&index=0&id=53fa3c38&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53fa3c38",
  null
  
)

export default component.exports